import Head from "next/head";
import LootOrbsTables from "../../../../src/tables/s15/LootOrbsTables.tsx";

export default function LootOrbsTablesPage({ tables }) {
  return (
    <>
      <Head>
        <title>TFT Set 15 Loot Orbs Tables</title>
      </Head>
      <LootOrbsTables tables={tables} />
    </>
  );
}
export async function getStaticProps() {
  const tablesResp = await fetch(
    `https://ap.tft.tools/static/s15/loot_orbs.json`,
  );
  const tables = await tablesResp.json();

  return {
    props: {
      tables,
    },
    revalidate: 3600,
  };
}
